module.exports = __webpack_public_path__ + "img/win.edaad69a.png";